<template>
	<template v-if="canShowRouterView">
		<EmptyLayout
			v-if="isBareLayout"
			class="app-authorized-window"
		>
			<router-view />

			<NotificationProvider />
		</EmptyLayout>

		<DefaultLayout
			v-else
			class="app-authorized-window"
		>
			<router-view />

			<NotificationProvider />
		</DefaultLayout>
	</template>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute, useRouter } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'
import NotificationProvider from '@/components/provides/NotificationProvider.vue'

/* Composables */
import useAuth from '@/composables/useAuth'

/* Stores */
import { useUserStore } from '@/stores/userStore'
import { useCompanyStore } from '@/stores/companyStore'
import { useCompanyNotificationStore } from '@/stores/companyNotificationStore'
import { useCompanyFavoriteLinksStore } from '@/stores/companyFavoriteLinksStore'
import { useApplicationStore } from '@/stores/applicationStore'

const router = useRouter()
const route = useRoute()

// страница вне каркаса приложения: без меню и без выбора компании (например, согласие OAuth)
const isBareLayout = computed(() => !!route.meta.isBareLayout)

const userStore = useUserStore()
const { availableCompanies } = storeToRefs(userStore)
const { setSelectedCompanyId } = userStore

const companyStore = useCompanyStore()
const companyNotificationStore = useCompanyNotificationStore()
const companyFavoriteLinksStore = useCompanyFavoriteLinksStore()
const applicationStore = useApplicationStore()

const { getDefinedCompanyId } = useAuth()

const canShowRouterView = ref(false)

onMounted(() => {
	// маршрут при первом входе может быть ещё не разобран — флаг страницы смотрим после готовности роутера
	router.isReady().then(() => {
		if (isBareLayout.value) return
		if (Array.isArray(availableCompanies.value) && availableCompanies.value.length === 0) {
			router.push({ name: 'CreateCompanyPage' })
		}
	})

	// загрузить юзера и список компаний
	getDefinedCompanyId(availableCompanies.value).then((companyId) => {
		// console.log('getDefinedCompanyId - then: companyId', companyId)
		if (companyId) {
			setSelectedCompanyId(companyId).then(() => {
				canShowRouterView.value = true
			})
		} else {
			canShowRouterView.value = true
		}
	})
})

onUnmounted(() => {
	companyStore.$reset()
	applicationStore.$reset()
	companyFavoriteLinksStore.$reset()
	companyNotificationStore.reset()
})
</script>
